<section
  class="banner-section banner-slider"
  *ngIf="isContent === false && slug === 'home'"
>
  <div class="banner-div" *ngIf="data?.featured?.length > 0">
    <owl-carousel-o [options]="mainslider">
      <ng-container *ngFor="let banner of data?.featured; let i = index">
        <ng-template carouselSlide [id]="'id_' + i">
          <div
            class="populer-slider"
            [routerLink]="banner | redirectUrl"
            [queryParams]="banner | queryParamUrl"
          >
            <div *ngIf="banner?.thumbnails.length > 0">
              <div class="series-banner">
                <div class="banner-box">
                  <div class="ratio-16-9 mb-0">
                    <div
                      class="banner-img"
                      [style.background-image]="'url(' + banner.thumbnail + ')'"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="banner?.thumbnails.length == 0">
              <div class="series-banner">
                <div class="banner-box">
                  <div class="ratio-16-9 mb-0">
                    <div
                      class="banner-img"
                      [style.background-image]="
                        'url(' + appconstant.bannerDefault + ')'
                      "
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</section>
<section class="banner-section" *ngIf="isContent === true && slug === 'home'">
  <div class="banner-div" *ngIf="data.featured?.length > 0">
    <owl-carousel-o [options]="mainslider">
      <ng-container *ngFor="let banner of data?.featured; let i = index">
        <ng-template carouselSlide [id]="'id_' + i">
          <div
            class="populer-slider"
            [routerLink]="banner | redirectUrl"
            [queryParams]="banner | queryParamUrl"
          >
            <div class="series-banner" *ngIf="banner">
              <div class="slide-content d-flex align-items-center">
                <div class="home-video-details">
                  <div>
                    <p class="active mb-1" *ngIf="banner.type == 'series'">
                      {{ "VIDEO_TYPE.SERIES" | translate }}
                    </p>
                    <p class="active mb-1" *ngIf="banner.type == 'video'">
                      {{ "VIDEO_TYPE.MOVIE" | translate }}
                    </p>
                  </div>
                  <h2>{{ banner.name }}</h2>

                  <!-- <h4
                    *ngIf="
                      banner?.type == 'series' &&
                      banner?.total_season > 0 &&
                      banner?.total_episode > 0
                    "
                  >
                    S{{ banner?.total_season }} E{{ banner?.total_episode }}
                  </h4> -->
                  <h6 *ngIf="banner?.type == 'video' || banner?.type == 'live'">
                    {{
                      banner.total_duration
                        ? (banner?.total_duration | second_time)
                        : ""
                    }}{{
                      banner?.published_year && banner.total_duration ? "," : ""
                    }}
                    {{ banner?.published_year ? banner?.published_year : "" }}
                    <span *ngIf="banner?.is_adult == 1">18+</span>
                  </h6>
                  <div *ngIf="banner?.genres.length > 0">
                    <p
                      class="text-secondary mb-2"
                      *ngIf="banner.type == 'series'"
                    >
                      <span
                        *ngFor="let item of banner?.genres; let isLast = last"
                      >
                        {{ item.name }}{{ isLast ? "" : ", " }}</span
                      >
                    </p>

                    <p
                      class="text-secondary mb-2"
                      *ngIf="banner.type == 'video' || banner.type == 'live'"
                    >
                      <span
                        *ngFor="let item of banner?.genres; let isLast = last"
                        >{{ item.name }}{{ isLast ? "" : ", " }}</span
                      >
                    </p>
                  </div>
                  <p class="description">
                    {{ banner?.description }}
                  </p>
                  <button
                    class="btn btn-theme"
                    [routerLink]="banner | redirectUrl"
                  >
                    <span class="icon-play-button mr-2"></span>
                    {{ "HOME.WATCH_NOW" | translate }}
                  </button>
                </div>
              </div>
              <div class="banner-box">
                <div class="ratio-16-9 mb-0">
                  <div
                    class="banner-img"
                    [style.background-image]="'url(' + banner.asset + ')'"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</section>
<section
  class="inner-banner-sect"
  *ngIf="
    data?.featured?.length > 0 && (slug === 'podcast' || slug === 'movies')
  "
>
  <owl-carousel-o [options]="innerslider">
    <ng-container *ngFor="let banner of data?.featured; let i = index">
      <ng-template carouselSlide>
        <div
          class="inner-banner-box"
          [routerLink]="banner | redirectUrl"
          [queryParams]="banner | queryParamUrl"
        >
          <div class="slider-titles mb-1">
            <p class="sub-title">{{ banner.duration | second_time }}</p>
            <h5 class="title">{{ banner.name }}</h5>
          </div>
          <div class="ratio-16-9" *ngIf="banner?.thumbnails.length > 0">
            <img src="{{ banner.thumbnail }}" />
          </div>
          <div class="ratio-16-9" *ngIf="banner?.thumbnails.length == 0">
            <img src="appconstant.bannerDefault " />
          </div>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</section>
